import getFeatureFlags, {
  isAutomaticAccountLoginEnabled
} from '../featureflags'
import logger from './logger'

export const getAccountFeatureFlags = (accountId, accountName, accountNameFromParam = false) => {
  if (accountName && accountNameFromParam) {
    logger.log('[CTI-Login] Using account name param for auto login', {
      accountName,
      source: 'parameter'
    })
    return Promise.resolve(true)
  }

  return accountId ? getFeatureFlags(accountId).then(flags => isAutomaticAccountLoginEnabled(flags)) : Promise.resolve(false)
}

export default getAccountFeatureFlags
